<template>
  <div
    :id="id"
    class="element shape triangle draggable"
    :class="[
      cssClasses,
      { selected: isSelected, locked },
    ]"
    :style="[basicStyles, transformStyles]"
  >
    <div
      class="shape-wrap"
      :class="[animationInStyle, animationOutStyle]"
    >
      <transition
        v-on:after-enter="afterEnter"
        v-on:before-leave="beforeLeave"
        :enter-active-class="'animated ' + animationIn"
        :leave-active-class="'animated ' + animationOut"
        :duration="{ leave: leaveDuration }"
        mode="">
        <div
          v-show="toggle"
          class="background"
          :data-test-image-optimized="backgroundMetaOptimizeApplied"
          :class="loopingClass"
          :style="[
            animationStyles,
            borderRadiusStyles,
            backgroundStyles,
            borderStyles,
            boxShadowStyles,
            blurStyles,
          ]"></div>
      </transition>
    </div>
  </div>
</template>

<script>
import ElementsMixins from '../../mixins/elements-mixins';
import MoveMixins from '../../mixins/move-mixins';
import ResizeMixins from '../../mixins/resize-mixins';

export default {
  name: 'TriangleElement',
  mixins: [ElementsMixins, ResizeMixins, MoveMixins],
  methods: {
    edit() {},
  },
};
</script>
